import type { FaireProductEntity } from "../../entity_types/product";

export const p_e732kddbu8: FaireProductEntity = {
  token: "p_e732kddbu8",
  type: "product",
  name: "Womens cottagecore clothing, Celestial moon leggings",
  brandToken: "b_na6tfqypxs",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3eb49d25e3e8df6b1c0b7a19c5492eab3dfc33064d3777e5c4bf1329be830e27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd5de616a5a106cecbaa2b67cbda6da2738062686d080fe2c49bc13fec6de2de.jpeg",
    "https://cdn.faire.com/fastly/1c5e32fef61f41048b779d07c03f1a7b988ecc338015a4ed6514512c7d4437a5.jpeg",
    "https://cdn.faire.com/fastly/eb6c3b7abf75721e3f0a2ee6d0fb945e8e887bf741334b68d183e04d17b6135b.jpeg",
    "https://cdn.faire.com/fastly/81e6d4ea840cc60e2b76261ee824eb4478466a40769280b3d1081378915b634c.jpeg",
    "https://cdn.faire.com/fastly/fc9747db5b32933f62fdf26b501d501f3010bc05e748a99e0f0a14acda7b3426.jpeg",
    "https://cdn.faire.com/fastly/ef76110f1f1ad7395b3225d846d8ad3d9d7784174d753deda3f948bc8cddccad.jpeg",
    "https://cdn.faire.com/fastly/f1e5140c25852502b72ce72f6e104aa3546e4232f3e4644ab3c007f1d03b8463.jpeg",
  ],
  priceDollars: 20.79,
  description:
    "Exclusive moon printed leggings\nDesigned to meet your everyday needs Triple Goddess Boutique’s exclusive collection can’t be found anywhere else. With two fully functional pockets designed to fit even the largest phones. 3” wide comfort waistband and custom fit to accommodate your unique body shape. The unique fabric blend will stretch to fit whether you are short or tall!!\nOS fits 2-12\nTC fits 12-18\nTC2 fits 18- 28\n92% polyester, 8% spandex",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:29.848Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
